import type { IconSvgObject } from './types';

const WalletDone01Icon: IconSvgObject = [
  ["path", { d: "M3 19L5 21L11 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16 3H5C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7H18V5C18 3.89543 17.1046 3 16 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11 21H19C20.1046 21 21 20.1046 21 19V9C21 7.89543 20.1046 7 19 7H7M3 14V5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M21 12H18C17.4477 12 17 12.4477 17 13V15C17 15.5523 17.4477 16 18 16H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default WalletDone01Icon;
